/* tslint:disable */
/* eslint-disable */
/**
 * Query Runner
 * Provides an API for running a query against records and returning detailed per query node match information.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { NoticeSearchQueryFilters } from './NoticeSearchQueryFilters';
import {
    NoticeSearchQueryFiltersFromJSON,
    NoticeSearchQueryFiltersFromJSONTyped,
    NoticeSearchQueryFiltersToJSON,
} from './NoticeSearchQueryFilters';
import type { NoticeSearchQueryScoreFilter } from './NoticeSearchQueryScoreFilter';
import {
    NoticeSearchQueryScoreFilterFromJSON,
    NoticeSearchQueryScoreFilterFromJSONTyped,
    NoticeSearchQueryScoreFilterToJSON,
} from './NoticeSearchQueryScoreFilter';

/**
 * 
 * @export
 * @interface NoticeSearchQuery
 */
export interface NoticeSearchQuery {
    /**
     * The page number to return, starting from 0
     * @type {number}
     * @memberof NoticeSearchQuery
     */
    page: number;
    /**
     * The number of results to return per page
     * @type {number}
     * @memberof NoticeSearchQuery
     */
    size: number;
    /**
     * The field to sort the results by
     * @type {string}
     * @memberof NoticeSearchQuery
     */
    sortBy: NoticeSearchQuerySortByEnum;
    /**
     * The order to sort the results by
     * @type {string}
     * @memberof NoticeSearchQuery
     */
    sortOrder: NoticeSearchQuerySortOrderEnum;
    /**
     * The minimum score to return. In the range of 10 - 30 at the moment
     * @type {number}
     * @memberof NoticeSearchQuery
     */
    minScore?: number;
    /**
     * The language codes to be used for the search. 
     *         Internally we currently support en, de, es, fr, and nl. 
     *         Other languages will fall back to the default analyzer.
     * @type {Array<string>}
     * @memberof NoticeSearchQuery
     */
    languages: Array<string>;
    /**
     * Query identifier, used for logging & debugging
     * @type {string}
     * @memberof NoticeSearchQuery
     */
    id: string;
    /**
     * 
     * @type {NoticeSearchQueryScoreFilter}
     * @memberof NoticeSearchQuery
     */
    scoreFilter?: NoticeSearchQueryScoreFilter;
    /**
     * 
     * @type {NoticeSearchQueryFilters}
     * @memberof NoticeSearchQuery
     */
    filters: NoticeSearchQueryFilters;
}


/**
 * @export
 */
export const NoticeSearchQuerySortByEnum = {
    Score: 'score',
    Title: 'title',
    AwardDate: 'awardDate',
    ExpiryDate: 'expiryDate',
    PublishedDate: 'publishedDate',
    Country: 'country',
    ValueAmount: 'valueAmount',
    CloseDate: 'closeDate'
} as const;
export type NoticeSearchQuerySortByEnum = typeof NoticeSearchQuerySortByEnum[keyof typeof NoticeSearchQuerySortByEnum];

/**
 * @export
 */
export const NoticeSearchQuerySortOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type NoticeSearchQuerySortOrderEnum = typeof NoticeSearchQuerySortOrderEnum[keyof typeof NoticeSearchQuerySortOrderEnum];


/**
 * Check if a given object implements the NoticeSearchQuery interface.
 */
export function instanceOfNoticeSearchQuery(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "sortBy" in value;
    isInstance = isInstance && "sortOrder" in value;
    isInstance = isInstance && "languages" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "filters" in value;

    return isInstance;
}

export function NoticeSearchQueryFromJSON(json: any): NoticeSearchQuery {
    return NoticeSearchQueryFromJSONTyped(json, false);
}

export function NoticeSearchQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NoticeSearchQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'sortBy': json['sortBy'],
        'sortOrder': json['sortOrder'],
        'minScore': !exists(json, 'minScore') ? undefined : json['minScore'],
        'languages': json['languages'],
        'id': json['id'],
        'scoreFilter': !exists(json, 'scoreFilter') ? undefined : NoticeSearchQueryScoreFilterFromJSON(json['scoreFilter']),
        'filters': NoticeSearchQueryFiltersFromJSON(json['filters']),
    };
}

export function NoticeSearchQueryToJSON(value?: NoticeSearchQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'sortBy': value.sortBy,
        'sortOrder': value.sortOrder,
        'minScore': value.minScore,
        'languages': value.languages,
        'id': value.id,
        'scoreFilter': NoticeSearchQueryScoreFilterToJSON(value.scoreFilter),
        'filters': NoticeSearchQueryFiltersToJSON(value.filters),
    };
}

